export class Personorg {
    organizationId: String;
    organization: String;
    relationtype: String;
    date_joined: Date;
    date_left: Date;
    membername: String;
    date_requested: Date;
    personId: String;
    member_function?:string;
    professionaldesc?:string;
    email:string;
    im?:string;
    address?:string;
    address2?:string;
    zip?:string;
    city?:string;
    phone?:string;
    avatarurl?:string;
}
